<template>
  <v-container fluid>
    <v-layout class="hide-on-print" row wrap>
      <v-flex xs12>
        <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
          <h3 class="font-weight-bold">Transfer details ({{ transfer_detail.status }})</h3>
        </v-flex>
        <v-card>
          <v-tabs
              background-color="primary"
              dark
              fixed-tabs
              height="40"
              v-model="tab">
            <v-tab href="#transfer-detail">
              <v-icon class="mr-2" size="15">mdi-account-card-details</v-icon>
              Transfer Detail
            </v-tab>
            <v-tab href="#history">
              <v-icon class="mr-2" size="15">mdi-history</v-icon>
              Transfer History
            </v-tab>

            <v-tabs-items v-model="tab">
              <v-tab-item value="transfer-detail">
                <v-card :loading="loading" class="pb-4" flat>
                  <v-card-text class="pb-0">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <confirmation-header-text class="ml-2" icon="mdi-alpha-t-box"
                                                  text="Transfer Details"/>

                      </v-flex>

                      <v-layout class="pl-6 pr-2" row wrap>
                        <v-flex xs3>
                          <list-item-detail
                              :sub_title="transfer_detail.transfer_data.document_type"
                              title="Document type"/>
                        </v-flex>

                        <v-flex xs3>
                          <list-item-detail
                              :sub_title="transfer_detail.transfer_data.document_number"
                              title="Document number"/>
                        </v-flex>

                        <v-flex v-if="transfer_detail.document_attached" xs3>
                          <dialog-file
                              :src="transfer_detail.transfer_data.document_file"></dialog-file>
                        </v-flex>
                        <v-flex xs3>
                          <list-item-detail
                              :sub_title="transfer_detail.transfer_data.document_validity"
                              title="Document Validity"/>
                        </v-flex>

                        <v-flex xs3>
                          <list-item-detail
                              :sub_title="transfer_detail.transfer_data.reason_for_transfer"
                              title="Reason for transfer"/>
                        </v-flex>

                        <v-flex xs3
                                v-if="transfer_detail.transfer_data && transfer_detail.transfer_data.recommendation_letter">
                          <label>Recommendation Letter</label>
                          <file-display :src="transfer_detail.transfer_data.recommendation_letter"></file-display>
                        </v-flex>
                      </v-layout>
                      <v-flex xs12>
                        <v-divider class="my-1"/>
                      </v-flex>
                      <v-flex class="d-flex justify-content-between" xs12>
                        <confirmation-header-text class="ml-2" icon="mdi-account"
                                                  text="Traveller Details"/>

                        <v-btn
                            @click="viewTravellerData"
                            color="primary"
                            dark
                            dense
                            text
                            x-small>
                          View Traveller History
                        </v-btn>
                      </v-flex>
                      <v-flex class="pl-3" xs3>
                        <list-item-detail :sub_title="transfer_detail.traveller.name"
                                          title="Traveller Name"/>
                      </v-flex>
                      <v-flex xs3>
                        <list-item-detail :sub_title="transfer_detail.traveller.gender"
                                          title="Traveller Gender"/>
                      </v-flex>
                      <v-flex xs3>
                        <list-item-detail :sub_title="transfer_detail.traveller.occupation"
                                          title="Traveller Occupation"/>
                      </v-flex>
                      <v-flex xs12>
                        <v-divider class="my-1"/>
                      </v-flex>
                      <v-flex class="d-flex justify-content-between" xs12>
                        <confirmation-header-text class="ml-2" icon="mdi-equal-box"
                                                  text="Current Visa Details"/>

                        <v-btn
                            @click="viewVisaDetail"
                            color="primary"
                            dark
                            dense
                            text
                            x-small>
                          View visa detail
                        </v-btn>
                      </v-flex>
                      <v-flex class="pl-3" xs3>
                        <list-item-detail :sub_title="transfer_detail.visa.visa_number"
                                          title="Visa Number"/>
                      </v-flex>
                      <v-flex xs3>
                        <list-item-detail :sub_title="transfer_detail.visa.submission_no"
                                          title="Submission Number"/>
                      </v-flex>
                      <v-flex xs3>
                        <list-item-detail :sub_title="transfer_detail.visa.visa_type"
                                          title="Visa Type"/>
                      </v-flex>
                      <v-flex xs3>
                        <list-item-detail
                            v-if="transfer_detail.visa.start_date != null && transfer_detail.visa.expiry_date != null"
                            :sub_title="transfer_detail.visa.start_date+' to '+transfer_detail.visa.expiry_date"
                            title="Visa Duration"/>
                      </v-flex>

                      <v-flex xs12>
                        <v-divider class="my-1"/>
                      </v-flex>
                      <v-flex v-if="transfer_detail.payment_info" xs12>
                        <payment-detail
                            :paid="transfer_detail.paid"
                            :payment_detail="transfer_detail.payment_info"
                        />
                      </v-flex>
                      <v-flex v-else xs12>
                        <confirmation-header-text class="ml-2" icon="mdi-alpha-p-box"
                                                  text="Payment Details"/>

                        <v-layout class="pl-3 mx-0" row wrap>
                          <v-flex xs3>
                            <list-item-detail
                                :sub_title="transfer_detail.transfer_data.cost"
                                title="Amount (USD)"
                            />
                          </v-flex>
                          <v-flex v-if="transfer_detail.voucher_number" xs3>
                            <list-item-detail :sub_title="transfer_detail.voucher_number"
                                              title="Voucher number"
                            />
                          </v-flex>
                        </v-layout>
                      </v-flex>

                      <v-footer class="sticky" color="blue darken-1" fixed height="auto">
                        <v-layout row v-if="!transfer_detail.is_verified && !transfer_detail.approve_rejected" wrap>
                          <v-spacer/>
                          <v-btn
                              @click="verify"
                              class="text-white"
                              color="blue ml-2"
                              v-if="transfer_detail.can_verify"
                          >
                            Verify
                          </v-btn>
                          <v-btn
                              @click="reject"
                              color="error mr-2 ml-2"
                              v-if="transfer_detail.can_verify"
                          >
                            Reject
                          </v-btn>
                        </v-layout>
                        <v-layout row v-else wrap>
                          <v-spacer/>
                          <v-btn
                              @click="generateTippani"
                              color="primary lighten-1 ml-2"
                              v-if="showGenerateTippani"
                          >
                            Generate tippani
                          </v-btn>
                          <v-btn
                              :loading="voucherLoading"
                              @click="generateVoucher"
                              class="text-white"
                              color="blue ml-2"
                              v-if="transfer_detail.tippani_generated && !transfer_detail.voucher_generated && transfer_detail.can_verify"
                          >
                            Generate voucher
                          </v-btn>
                          <v-btn
                              @click="print('voucher')"
                              class="text-white"
                              color="blue ml-2"
                              v-if="transfer_detail.voucher_generated && transfer_detail.can_verify && !transfer_detail.paid"
                          >
                            Print voucher
                          </v-btn>
                          <v-btn
                              @click="checkPaymentStatus"
                              color="primary lighten-1 ml-2"
                              v-if="transfer_detail.voucher_number && !transfer_detail.paid && transfer_detail.can_verify"
                          >
                            Check payment status
                          </v-btn>
                          <v-btn
                              @click="checkPaymentManually"
                              color="primary lighten-1 ml-2"
                              v-if="transfer_detail.voucher_generated && !transfer_detail.paid && transfer_detail.can_verify"
                          >
                            Pay manually
                          </v-btn>
                          <v-btn
                              @click="reject"
                              color="error mr-2 ml-2"
                              v-if="transfer_detail.paid && !transfer_detail.approve_rejected && transfer_detail.can_verify"
                          >
                            Reject
                          </v-btn>
                          <v-btn
                              @click="approve"
                              color="primary"
                              v-if="transfer_detail.paid && !transfer_detail.approve_rejected && transfer_detail.can_approve"
                          >
                            Approve
                          </v-btn>
                          <v-btn
                              @click="printNow"
                              :loading="loading"
                              class="white--text"
                              color="primary ml-2"
                              v-if="transfer_detail.visa_print_system_active && transfer_detail.approve_rejected && transfer_detail.can_approve && $oauth.checkIfHasPermission(['print visa-transfer'])"
                          >
                            Print Visa Transfer
                          </v-btn>
                        </v-layout>
                      </v-footer>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item value="detail">
                <v-card :loading="loading" class="pb-4" flat>
                  <old-visa-detail :visa_request="visaRequest" v-if="isOld"/>
                  <paid-visa-detail
                      v-else
                      :visa_request="visaRequest"
                      :voucherLoading="voucherLoading"
                  />

                </v-card>
              </v-tab-item>

              <v-tab-item value="history">
                <v-card :loading="loading" flat>
                  <visa-history :history="transfer_detail.history"
                                :show_load_more="false" :transfer="true" :editable="true"/>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-card>
      </v-flex>
      <v-flex v-if="!transfer_detail.voucher_number" xs12>
        <v-dialog v-model="tippaniDialog"
                  width="800">
          <v-card class="hide-on-print">
            <v-toolbar color="blue darken-3" dark>
              <v-toolbar-title>Generate tippani</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <div :class="{'hide-on-block':step === 2}">
                <v-layout row wrap>
                  <v-flex class="mt-4" xs12>
                    <div id="editor"></div>
                  </v-flex>
                </v-layout>
              </div>
              <div v-if="step === 2">
                <transfer-tippani-print/>
              </div>
            </v-card-text>
            <v-card-actions class="mt-8">
              <v-spacer/>
              <v-btn @click="cancel" color="error" class="white--text">Cancel</v-btn>
              <v-btn @click="next" color="primary" v-if="step === 1">Next</v-btn>
              <v-btn @click="save" color="primary" v-if="step === 2">Save</v-btn>
              <v-btn @click="print('tippani')" color="primary" v-if="step === 2">Print</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      <v-dialog v-model="fileDialog" width="700">
        <v-card class="hide-on-print">
          <v-toolbar color="blue darken-3" dark>
            <v-toolbar-title>Verify</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="mt-8 pb-0">
            <file-input
                :required="true"
                label="New Document (Passport/Travelling Document/ Stay Order)"
                v-model="transfer_document_file"
                :fileSize="2048"
            ></file-input>
          </v-card-text>
          <v-card-actions class="mt-8">
            <v-spacer/>
            <v-btn @click="fileDialog = false" color="error">Cancel</v-btn>
            <v-btn :loading="loading"
                   @click="saveFile"
                   color="primary"
            >
              Verify
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-flex xs12>
        <v-dialog v-model="approveModal"
                  width="700">
          <v-form class="mt-4" ref="approveRef">
            <v-card>
              <v-toolbar color="blue darken-3" dark>
                <v-toolbar-title>Approve transfer</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-text-field
                    label="Remarks"
                    outlined
                    v-model="approveData.remarks"
                />
                <multiple-file-upload
                    :required="false"
                    label="Attachement (Max file size 2MB)"
                    v-model="approveData.files"
                />
              </v-card-text>
              <v-card-actions>
                <v-spacer/>
                <v-btn @click="cancel" color="error">Cancel</v-btn>
                <v-btn @click="approveTransfer" color="primary">Approve</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>

        </v-dialog>
        <v-dialog v-model="rejectModal"
                  width="800">
          <v-card>
            <v-toolbar color="blue darken-3" dark>
              <v-toolbar-title>Reject transfer</v-toolbar-title>
            </v-toolbar>

            <v-card-text>
              <v-form ref="rejectRef">
                <v-textarea
                    :rules="[rules.required]"
                    label="Reason for Rejection"
                    outlined
                    class="mt-3"
                    v-model="rejectData.remarks"
                />

                <file-input
                    :required="true"
                    label="New Rejected Document (Passport/Travelling Document/ Stay Order) *"
                    v-model="rejectData.file"
                    v-if="!transfer_detail.is_verified"
                ></file-input>

                <multiple-file-upload :required="false" label="Attachment (Max file size 2MB)"
                                      v-model="rejectData.files"/>
              </v-form>

            </v-card-text>
            <v-card-actions>
              <v-spacer/>
              <v-btn @click="cancel" color="error">Cancel</v-btn>
              <v-btn @click="rejectTransfer" color="primary">Reject</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
    <transfer-tippani-print class="show-on-print" v-if="printType === 'tippani'"/>
    <voucher-content
        :data="transfer_detail"
        class="show-on-print"
        v-if=" printType === 'voucher'"
    />
    <manual-payment-dialog :url="'pay-track-manually/'+transfer_detail.submission_no" @paid="paid"
                           v-model="manualDialog"/>
    <cost-exemption-dialog
        :url="'exempt-cost/'+transfer_detail.submission_no"
        @exempted="exempted"
        v-model="costExemptedDialog"
    />
  </v-container>

</template>

<script>
import {
  APPROVE_VISA_TRANSFER,
  PRINT_VISA_TRANSFER,
  CHECK_VISA_TRANSFER_PAYMENT_STATUS,
  GENERATE_TRANSFER_VOUCHER,
  GET_VISA_TRANSFER,
  REJECT_VISA_TRANSFER,
  SAVE_VISA_TRANSFER_TIPPANI,
  VERIFY_TRANSFER_CERTIFICATION
} from "../../../store/action-type";
import ListItemDetail from "../../../components/ListItemDetail";
import HeaderText from "../../../components/HeaderText";
import ConfirmationHeaderText from "../../../components/ConfirmationHeaderText";
import DialogFile from "../../../components/FileDisplay";
import FileInput from "../../../components/FileInput";
import PaymentDetail from "../../../components/PaymentDetail";
import Quill from 'quill'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import {SET_TRANSFER_TIPPANI_PRINT_CONTENT} from "../../../store/mutation-type";
import TransferTippaniPrint from "../../../components/tippani/TransferTippaniPrint";

import {validationMixin} from '../../../mixins/validationMixin'
import MultipleFileUpload from "../../../components/MultipleFileUpload";
import VoucherContent from "../../../components/VoucherContent";
import PaidVisaDetail from "../../../views/visa/visa-request/PaidVisaDetail";
import VisaHistory from "../../../views/visa/visa-request/VisaHistory";
import ManualPaymentDialog from "../../../components/dialogs/ManualPaymentDialog";
import CostExemptionDialog from "../../../components/dialogs/CostExemptionDialog";
import OldVisaDetail from "./OldVisaDetail";
import {mapGetters} from "vuex";
import FileDisplay from "@/components/FileDisplay";

export default {
  name: "VisaTransferView",
  components: {
    FileDisplay,
    ListItemDetail,
    HeaderText,
    DialogFile,
    TransferTippaniPrint,
    FileInput,
    MultipleFileUpload,
    VoucherContent,
    ManualPaymentDialog,
    PaymentDetail,
    CostExemptionDialog,
    OldVisaDetail,
    ConfirmationHeaderText,
    PaidVisaDetail,
    VisaHistory
  },
  data() {
    return {
      tippaniDialog: false,
      step: 1,
      quill: null,
      approveModal: false,
      rejectModal: false,
      printType: null,
      tab: null,
      manualDialog: false,
      costExemptedDialog: false,
      fileDialog: false,
      transfer_document_file: null,
      loading: false,
      voucherLoading: false
    }
  },
  mixins: [validationMixin],
  computed: {
    ...mapGetters('VisaRequestSingle', ['visaRequest']),
    isOld() {
      const submission_no = this.transfer_detail.visa.submission_no;
      return submission_no === undefined ? false : submission_no.substr(0, 1).toLowerCase() === 'o';
    },
    transfer_detail() {
      return this.$store.state.Transfer.transferDetail;
    },
    approveData() {
      return this.$store.state.Transfer.approveData;
    },
    rejectData() {
      return this.$store.state.Transfer.rejectData;
    },
    showGenerateTippani() {
      const {voucher_generated, can_verify, document_attached} = this.transfer_detail;
      return !voucher_generated && can_verify && document_attached;
    }
  },
  methods: {
    async saveFile() {
      if (!this.transfer_document_file) {
        this.$store.commit('Notification/showError', 'Enter document file');
        return;
      }
      try {
        this.loading = true;
        const {data} = await this.$store.dispatch(VERIFY_TRANSFER_CERTIFICATION, {
          file: this.transfer_document_file
        });
        this.loading = false;
        this.$store.commit('Notification/showSuccess', data.message);
        this.fileDialog = false;
        await this.$store.dispatch(GET_VISA_TRANSFER, this.$route.params.id)
      } catch (e) {
        this.loading = false;
        this.$store.commit('Notification/showError', e.response.data.message)
      }
    },
    showFileDialog() {
      this.fileDialog = true;
    },
    async generateVoucher() {
      try {
        this.voucherLoading = true;
        await this.$store.dispatch(GENERATE_TRANSFER_VOUCHER);
        this.$store.commit('Notification/showSuccess', 'Voucher generated successfully')
      } catch (e) {
        this.$store.commit('Notification/showError', 'Voucher generated successfully');
        this.voucherLoading = false;
      }

    },
    viewTravellerData() {
      window.open('/system/travellers-history/view/' + this.transfer_detail.traveller.id)
    },
    viewVisaDetail() {
      window.open('/system/visa-requests/view/' + this.transfer_detail.visa.submission_no, '_blank')
    },
    next() {
      this.$store.commit(SET_TRANSFER_TIPPANI_PRINT_CONTENT, this.quill.root.innerHTML);
      this.step = 2;
    },
    paid() {
      this.$store.dispatch(GET_VISA_TRANSFER, this.$route.params.id);
    },
    print(type) {
      this.printType = type;
      setTimeout(() => {
        window.print();

      }, 200);
    },
    approve() {
      this.approveModal = true;
    },
    approveTransfer() {
      if (this.$refs.approveRef.validate()) {
        this.$store.dispatch(APPROVE_VISA_TRANSFER).then(() => {
          this.approveModal = false;
          this.$store.commit('Notification/showSuccess', 'Transfer has been approved');
          this.$store.dispatch(GET_VISA_TRANSFER, this.$route.params.id)
        }).catch((err) => {
          this.$store.commit('Notification/showError', 'Something went wrong')
        })
      }
    },
    rejectTransfer() {
      if (this.$refs.rejectRef.validate()) {
        this.$store.dispatch(REJECT_VISA_TRANSFER).then((res) => {
          this.rejectModal = false;
          this.$store.commit('Notification/showSuccess', 'Transfer has been rejected');
          this.$store.dispatch(GET_VISA_TRANSFER, this.$route.params.id)

        }).catch((err) => {
          this.$store.commit('Notification/showError', 'Something went wrong')
        })
      }
    },
    reject() {
      this.rejectModal = true;
    },
    exempted(data) {
      this.transfer_detail.cost_exempted = true;
      this.transfer_detail.transfer_data.exempt_cost = data;
      this.transfer_detail.transfer_data.cost = this.transfer_detail.transfer_data.cost - data;
    },
    checkPaymentStatus() {
      this.$store.dispatch(CHECK_VISA_TRANSFER_PAYMENT_STATUS, this.transfer_detail.submission_no).then((res) => {
        this.$store.commit('Notification/showSuccess', res.data.message);
      }).catch((err) => {
        this.$store.commit('Notification/showError', err.response.data.message)
      })
    },
    verify() {
      this.fileDialog = true;

    },
    async save() {
      await this.$dialog.confirm({
        text: "Are you sure want to save tippani ? (Tippani once save cannot be reverted )",
        actions: {
          false: "No",
          true: {
            text: "Yes",
            handle: () => {
              this.$store.dispatch(SAVE_VISA_TRANSFER_TIPPANI, this.quill.root.innerHTML).then((res) => {
                this.$store.commit('Notification/showSuccess', 'Tippani has been generated');
                this.step = 1;
                this.tippaniDialog = false;
              }).catch((err) => {
                this.$store.commit('Notification/showError', err.response.data.message)
              });
            }
          }
        }
      });

    },
    cancel() {
      if (this.step === 1) {
        this.tippaniDialog = false;
      } else {
        this.step = 1;
      }
      this.approveModal = false;
      this.rejectModal = false;

    },
    generateTippani() {
      if (this.transfer_detail.voucher_number) {
        window.print();
      } else {
        let tippani = "माथि उल्लेखित विवरण भएका व्यक्ति सन् @start_date मा @visa_type @issued_office बाट लिएको अध्यागमन सूचना प्रणालीबाट देखिएकाले निजको नया @document_type (न. @document_number) मा अध्यागमन नियमावली २०५१ को अनुसूची -९ को ११ (ग) बमोजिम 2 अमेरिकी डलर बराबरको नेपाली मुद्रा दस्तुर लिई भिसा स्थानान्तरण गरिदिन निर्णयार्थ पेश गरेको छु |";
        this.tippaniDialog = true;
        let content = tippani;
        content = content.replace('@transfer_cost', this.transfer_detail.transfer_data.cost);
        content = content.replace('@start_date', this.transfer_detail.visa.start_date);
        content = content.replace('@visa_type', this.transfer_detail.visa.visa_type);
        content = content.replace('@document_type', this.transfer_detail.transfer_data.document_type);
        content = content.replace('@document_number', this.transfer_detail.transfer_data.document_number);
        content = content.replace('@issued_office', this.transfer_detail.visa.issued_office);
        setTimeout(() => {
          if (!this.quill)
            this.quill = new Quill('#editor', {
              theme: 'snow',
              modules: {
                toolbar: [
                  [{header: [1, 2, false]}],
                  ['bold', 'italic', 'underline'],
                ],
              },
            });
          this.quill.root.innerHTML = content;
        }, 100);
      }

    },
    checkPaymentManually() {
      this.manualDialog = true;
    },
    printNow(o) {
      var self = this;
      self.loading = true;
      if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open) {
        // console.log(this.visa_request.prn_file_content)
        this.$store.dispatch(PRINT_VISA_TRANSFER).then(() => {
          //Create a ClientPrintJob
          var cpj = new JSPM.ClientPrintJob();
          //Set Printer type (Refer to the help, there many of them!)
          cpj.clientPrinter = 0;
          cpj.printerCommandsCodePage = -1;
          //Set printer commands...
          cpj.printerCommands = self.transfer_detail.prn_file_content;
          cpj.sendToClient();
          this.$store.commit("Notification/showSuccess", "Visa transfer printed track generated successfully");
          self.loading = false;
        })
            .catch(error => {
              this.$store.commit('Notification/showError', error.response.data.message)
              self.loading = false;
            });
      } else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Closed) {
        self.loading = false;
        this.$store.commit('Notification/showError', "JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm")
        return false;
      } else if (
          JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Blocked
      ) {
        self.loading = false;
        this.$store.commit('Notification/showError', "JSPM has blocked this website!")
        return false;
      }

    },
    jspmWSStatus() {
      if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open)
        return true;
      else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Closed) {
        // alert(
        //     "JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm"
        // );
        return false;
      } else if (
          JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Blocked
      ) {
        // alert("JSPM has blocked this website!");
        return false;
      }
    },
  },
  mounted() {
    this.$store.dispatch(GET_VISA_TRANSFER, this.$route.params.id)
    JSPM.JSPrintManager.auto_reconnect = true;
    JSPM.JSPrintManager.start();
    const self = this;
    JSPM.JSPrintManager.WS.onStatusChanged = function () {
      if (self.jspmWSStatus()) {
        //get client installed printers
        JSPM.JSPrintManager.getPrinters().then(function (myPrinters) {
          // var options = "";
          // for (var i = 0; i < myPrinters.length; i++) {
          //   options += "<option>" + myPrinters[i] + "</option>";
          // }
          console.log(myPrinters);
          // $("#installedPrinterName").html(options);
          self.printers = myPrinters;
        });
      }
    };
  }
}
</script>
